<template>
	<div class="c-s z-ant-input" v-if="isShow" style="position: fixed;top: 0;height: 100vh;z-index: 999;">
		<div :show="isShow" @click="_click(false) " style="position: initial;background-color: rgba(0, 0, 0, 0.7);height: 100%;width: var(--theme-max-width);" z-index="4" >
			 <div class="wrapper" >
				<div style="">
					<div class="ant-modal-content" @click.stop>
							<div class="ant-modal-header"><div id="rcDialogTitle1" class="ant-modal-title">Agregar cuenta</div></div>
							<div class="ant-modal-body">
								<div class="gD0G2pAAJZZTJ1n0KQXv" >
									<!-- margin-bottom: .5rem; -->
									<antInput  :clearable='false' @onInput="_onInput" :modelValue="forData.account_name" form-key='account_name'
										:placeholder="$t('components._Introduzaoseunomereal')">
										<div slot="left"
											style="color: var(--theme-text-color-darken);font-size:.18rem;display: flex;align-items: center;">
											<svg-icon className="prefix"
												icon-class="input_icon_zsxm--svgSprite:all" />
										</div>
									</antInput>
								</div>
								<div class="gD0G2pAAJZZTJ1n0KQXv">
									<antS @_click="chooseType" :dados="['CLABE','BANK']" :modelvalue="accountType">
										<div slot="left-icon"
										style="color: var(--theme-text-color-darken);font-size:.18rem;display: flex;align-items: center;"
										>
										<svg style="width: .36rem;height: .36rem;" fill="currentColor" viewBox="0 0 16 16">
											<path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z"/>
											<path d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z"/>
										</svg>
										</div>
									</antS>
								</div>
								<div class="gD0G2pAAJZZTJ1n0KQXv" v-if="isBANK">
									<antS @_click="chooseBank" :dados="bankList" :modelvalue="nowBank" fontSizeClass="spanfontsize18">
										<div slot="left-icon" style="color: var(--theme-text-color-darken);font-size:.18rem;display: flex;align-items: center;" >
										<svg-icon className="prefix" icon-class="input_icon_bank--svgSprite:all" />
										</div>
									</antS>
								</div>
								<div class="gD0G2pAAJZZTJ1n0KQXv">
									<antInput type="number" maxlength="30" :modelValue="forData.account_cpf" @onInput="_onInput" :clearable='false' form-key='account_cpf'
										placeholder="Ingrese su cuenta No.">
										<div slot="left"
											style="color: var(--theme-text-color-darken);font-size:.18rem;display: flex;align-items: center;">
											<svg style="vertical-align: -0.15em;width: .36rem;height: .36rem;" fill="currentColor" viewBox="0 0 16 16">
												<path fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm9 1.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM9 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 9 8Zm1 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm-1 2c0 .17-.014.337-.04.5H2a1 1 0 0 1-.984-.819C1.2 10.398 2.914 9 5 9c2.21 0 4 1.567 4 3.5ZM7 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"/>
											</svg>
										</div>
									</antInput>
								</div>
								<div class="Kw58s_FCuipHRV_EW4tG">
									<span>{{ $t('withdraw._Verifique') }} </span>
								</div>
								<div class="Pt3rGlTmq0_WLpTGHsA_" @click="setBank">
									<van-button class="JHBAn8W0jkHI1OM_X2fy" type="primary">{{ $t('withdraw._Confirmar') }}</van-button>
								</div>
							</div>
					</div>
				</div>
				
			</div>
		</div>
		
	</div>
</template>

<script>
	import {
		setBank
	} from "@/apis/modules/login.js"
	import antInput from "./input.vue"
	import antInputPassword from "@/components/ant-input-password/index.vue"
	import antS from "./ant-s.vue"
	import { Toast } from 'vant';
	export default{
		components:{
			antInputPassword,
			antInput,
			antS
		},
		props:{
			isShow:{
				type:Boolean,
				default: false,
			},
			formDta:{
				type:[Object],
				default:()=>{return {}},
				
			}
			
		},
		data() {
			return{
				show:true,
				isShowNum:false,
				shuruKOangName:'',
				accountType:0,
				nowBank:0,
				isBANK:true,
				forData:{
					account_name:'',
					account_pix:'',
					account_cpf:'',
					account_type:'CLABE',
				},
				bankList : [
					'Por favor seleccione un banco',
					'ABC CAPITAL','ACTINVER','AFIRME','ALTERNATIVOS','ARCUS','ASP INTEGRA OPC','AUTOFIN','AZTECA','BAJIO','BANAMEX','BANAMEX2','BANCO COVALTO',
					'BANCO S3','BANCOMEXT','BANCOPPEL','BANCREA','BANJERCITO','BANK_OF AMERICA','BANK OF CHINA','BANKAOOL','BANOBRAS','BANORTE','BANREGIO','BANSI',
					'BANXICO','BARCLAYS','BBASE','BBVA MEXICO','BMONEX','BABIEN','CAJA POP MEXICA','CAJA TELEFONIST','CB INTERCAM','CI BOLSA','CIBANCO','CITI MEXICO',
					'CLS','COMPARTAMOS','CONSUBANCO','CREDICAPITAL','CREDICLUB','CREDIT SUISSE','CRISTOBAL COLON','CODI VALIDA','CUENCA','DONDE','EVERCORE','FINAMEX',
					'FINCOMUN','FOMPED','FONDEADORA','FONDO FIRA','GBM','HIPOTECARIA FED','HSBC','ICBC','INBURSA','INDEVAL','INMOBILIARIO','INTERCAM_BANCO','INVERCAP',
					'INVEX','JP MORGAN','KUSPIT','LIBERTAD','MASARI','MIFEL','MIZUHO BANK','MONEXCB','MUFG','MULTIVA BANCO','MULTIVA CBOLSA','MERCADO PAGO W','NAFIN',
					'NU MEXICO','NVIO','PAGATODO','PROFUTURO','REFORMA','SABADELL','SANTANDER','SCOTIABANK','SHINHAN','SPIN BY OXXO','STP','TESORED','TRANSFER',
					'UNAGRA','VALMEX','VALUE','VE POR MAS','VECTOR','VOLKSWAGEN',
				],
			}
		},
		watch: {
		    // 当message变化时，这个函数就会被调用
		    isShow(newValue, oldValue) {
				this.forData = this.formDta.account_type ? {...this.formDta} : {account_name:'',account_pix:'',account_cpf:'',account_type:'CLABE',};
				if(this.forData.account_type){
					this.accountType=['CLABE','BANK'].indexOf(this.forData.account_type);
					if(this.accountType==-1){
						this.accountType=0;
					}
				}
				this.isBANK=true;
				this.nowBank = this.forData.account_pix || 0;
				
		  //     console.log(this.forData,newValue);
		      // 这里可以添加更多响应数据变化的逻辑
		    }
		  },
		methods:{
			_click(){
				this.$emit('_click',false)
			},
			chooseType(item,index){
				this.accountType=index;
				this.forData.account_type=item;
				this.isBANK=true;
			},
			chooseBank(item,index){
				this.nowBank=index;
				this.forData.account_pix=index;
			},
			_onInput(v,k){
				this.forData[k]=v;
			},
			setBank(){
				let msg = '';
				if(!this.forData.account_name)msg = this.$t('_homeTile_tab._campodeNomereal');
				if(!msg && this.forData.account_pix < 1){msg = 'Por favor seleccione un banco'}
				if(!msg && (!this.forData.account_cpf || this.forData.account_cpf.length < 11)){msg = 'Ingrese su cuenta No.'}
				if(!msg && this.accountType == 0 && this.forData.account_cpf.length != 18){msg = 'Ingrese su cuenta No.'}
				if(msg){
					Toast.fail({
						message:this.myLineBreaks(msg),
						duration:0
					});
					setTimeout(()=>{
						Toast.clear()
					},1000)
					return false;
				}

				setBank({...this.forData}).then(({code,msg,data})=>{
					if(code==0){
						Toast.success({
							message:this.myLineBreaks(msg),
							duration:1000
						});
						setTimeout(()=>{
							location.reload();
							this.$attrs.getBank();
							this.$emit('onIsShow',false)
						},1500)
						return false;
					}
					Toast.loading({
						message:this.myLineBreaks(msg),
						duration:1000
					});
				})
			}
		}
	}
</script>
<style>
/* 	.c-s{
		width: 100%;
		height: 100vh;
	} */
	.c-s{
		width: 100vw;
	}
	.c-s .van-overlay{
		width: 100vw;
		/* position: absolute;
		    background-color: rgba(0, 0, 0, .45); */
	}
	.van-field__body input{
		font-size: 0.27rem;
	}
</style>
<style scoped>
	
	.wrapper{
		 display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		width: 100%;
	}
	 .ant-modal-content {
	    background-color: var(--theme-main-bg-color);
	    border-width: thin;
	    border-style: solid;
	    border-image: initial;
		box-sizing: border-box;
		width: 6.9rem;
	    border-color: var(--theme-color-line);
	    border-radius: 0.2rem;
	    max-height: calc(var(--vh, 1vh)*100 - .1rem);
	    overflow: auto;
	    position: static;
		margin: 0 auto;
	}
	.gD0G2pAAJZZTJ1n0KQXv{
		margin-bottom: .5rem;
	}
	.ant-modal-header{
		 background-color: var(--theme-main-bg-color);
		    border-bottom: none;
		    border-radius: .2rem .2rem 0 0;
		    padding: .2rem .3rem
	}
	.ant-modal-title{
			color: var(--theme-text-color-darken);
		    font-size: .24rem;
		    font-weight: revert;
		    line-height: .34rem;
		    text-align: center;
	}
	.Ou1aviPriFX421w97dGA{
		display: flex;
		align-items: center;
		justify-content: space-between;
		    margin-bottom: .15rem;
		    font-size: .22rem;
			    color: var(--theme-text-color-darken);
	}
	.Ou1aviPriFX421w97dGA .ZaAWGnvFuhPwlBk40od_{
		font-size: .36rem;
		width: .36rem;
		height: .36rem;
		    color: var(--theme-text-color-lighten);
	}
	.Ou1aviPriFX421w97dGA .isShowNum .ZaAWGnvFuhPwlBk40od_{
		color: var(--theme-primary-color);
	}
	.ant-modal-body{
		    padding-top: .2rem !important;
		    padding: .3rem;
	}
	.Kw58s_FCuipHRV_EW4tG{
		    color: var(--theme-text-color-darken);
		    font-size: .22rem;
			display: flex;
	}
	._7B8oTwzAn2VmdNYw3F0z {
	    color: var(--theme-primary-color);
	    cursor: pointer;
	    text-align: right;
	}
	.closeIcon{
		
	}
	.QzRd3YqTnYxG8Latq8fW {
	    background: none;
	    height: .64rem;
	    width: .64rem;
		margin: 0 auto;
	}
	.QzRd3YqTnYxG8Latq8fW img{
		width: 100%;
		height: 100%;
	}
	.JHBAn8W0jkHI1OM_X2fy {
	    border-radius: .14rem;
	    font-size: .24rem;
		width: 100%;
	    height: .7rem;
		 background-color: var(--theme-primary-color);
		border-color: var(--theme-primary-color);
	    line-height: .7rem;
	}
</style>